import React from 'react';
import { useContext } from 'react';
import { FilterContext } from '../../context/Filter';

const JCcardtable = (props) => {

    const { open } = useContext(FilterContext);

    return (

        <div
            className={`  w-96 md:w-full   mt-5 border rounded-lg overflow-x-auto overflow-hidden `}
        >
            <div className="bg-[#2374BF] text-white pl-2 p-1  text-md font-semibold">
                {props.heading}
            </div>

            {props.vcards}

            {props.des}

        </div>
    );
};

export default JCcardtable;
